import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  getTenant,
  isTenantLockedBySubdomain,
  resolveAuthTenantId,
  syncSubdomainTenantToLocalStorage,
} from "../common/Utils";
import { DEFAULT_TENANT } from "../environment";

export function useAuthTenant() {
  const [searchParams] = useSearchParams();
  const isTenantFromSubdomain = isTenantLockedBySubdomain();

  const [tenant, setTenant] = useState<string | undefined>(() =>
    resolveAuthTenantId(searchParams.get("tenant")).tenantId
  );
  const [tenantResolved, setTenantResolved] = useState(false);

  useEffect(() => {
    syncSubdomainTenantToLocalStorage();

    if (isTenantFromSubdomain) {
      const { tenantId } = resolveAuthTenantId();
      if (tenantId) {
        setTenant(tenantId);
      }
      return;
    }

    const tenantParam = searchParams.get("tenant");
    if (tenantParam) {
      setTenant(tenantParam);
      return;
    }

    setTenant((current) => current || getTenant() || DEFAULT_TENANT || undefined);
  }, [searchParams, isTenantFromSubdomain]);

  const hideTenantInput = isTenantFromSubdomain || tenantResolved;

  return {
    tenant,
    setTenant,
    tenantResolved,
    setTenantResolved,
    hideTenantInput,
    isTenantFromSubdomain,
  };
}
